import React, { useEffect, useState } from "react";
import { Loader, Confirm, Input, Button, Icon } from "semantic-ui-react";
import { Student } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable } from "../../../Shared";
import { BasicModal } from "../../../../components/Shared";
import {
  AcademicHistory,
  ListGrades,
} from "../../../../components/Student/MyGrades";
import { RecoveryGradeForm } from "../RecoveryGradeForm";
import { EditGradeForm } from "../EditGradeForm";
import "./ListStudent.scss";

const studentController = new Student();

export function ListStudent(props) {
  const { gradeId, academicCycle, reload, onReload } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { accessToken } = useAuth();

  const [students, setStudents] = useState(null);
  const [studentActive, setStudentActive] = useState(null);
  const [filters, setFilters] = useState({ name: "", dni: "", phone: "" });
  const [searchInputs, setSearchInputs] = useState({ name: "", dni: "", phone: "" });

  const [showConfirm, setShowConfirm] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [academicHistoryActive, setAcademicHistoryActive] = useState(null);
  const [showModalAcademicHistory, setShowModalAcademicHistory] =
    useState(false);

  const [showRecoveryModal, setShowRecoveryModal] = useState(false);
  const [recoveryActiveCourse, setRecoveryActiveCourse] = useState(null);

  const [showEditGradeModal, setShowEditGradeModal] = useState(false);
  const [editGradeActiveCourse, setEditGradeActiveCourse] = useState(null);

  const onOpenCloseModalAcademicHistory = (row) => {
    if (row && row.SyllabuSubjectGrade && row.SyllabuSubjectGrade.subject) {
      setStudentActive(row.studentId);
      setAcademicHistoryActive(row);
      setShowModalAcademicHistory(true);
      setSelectedCourse(row.SyllabuSubjectGrade.subject.name);
    } else {
      setStudentActive(null);
      setShowModalAcademicHistory(false);
      setAcademicHistoryActive(null);
      setSelectedCourse(null);
    }
  };

  const onOpenCloseConfirm = (row) => {
    setStudentActive(row);
    setShowConfirm((prevState) => !prevState);
  };

  const onOpenCloseEditGradeModal = (row) => {
    if (row) {
      setEditGradeActiveCourse(row);
      setShowEditGradeModal(true);
    } else {
      setEditGradeActiveCourse(null);
      setShowEditGradeModal(false);
    }
  };

  const onOpenCloseRecoveryModal = (row) => {
    if (row && row.averageGrade <= 10) {
      setRecoveryActiveCourse(row);
      setShowRecoveryModal(true);
    } else if (!row) {
      setRecoveryActiveCourse(null);
      setShowRecoveryModal(false);
    }
  };

  const onDelete = async () => {
    try {
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const getProgressColor = (fieldValue, row) => {
    const progress = row.progress || 0;
    if (progress < 60) return "red";
    if (progress < 80) return "yellow";
    return "green";
  };

  const getProgressText = (fieldValue, row) => {
    const progress = row.progress || 0;
    return `${progress}%`;
  };

  const getStatusColor = (fieldValue, row) => {
    // Si recoveryStatus = 2, significa que hay nota de recuperación
    if (row.recoveryStatus === 2) {
      if (row.recoveryGrade >= 11) return "blue"; // Recuperado - azul
      return "red"; // Desaprobado
    }
    // Si no tiene recuperación, evaluar por promedio normal
    if (row.averageGrade >= 11) return "green";
    if (row.averageGrade <= 10) return "red";
    return "brown";
  };

  const getStatusText = (fieldValue, row) => {
    // Si recoveryStatus = 2, significa que hay nota de recuperación
    if (row.recoveryStatus === 2) {
      if (row.recoveryGrade >= 11) return "RECUPERADO";
      return "DESAPROBADO";
    }
    // Si no tiene recuperación, evaluar por promedio normal
    if (row.averageGrade >= 11) return "APROBADO";
    if (row.averageGrade <= 10) return "DESAPROBADO";
    return "SIN DEFINIR";
  };

  const getRecoveryGradeDisplay = (row) => {
    // Si recoveryStatus = 1, mostrar "-"
    if (row.recoveryStatus === 1) return "-";
    // Si recoveryStatus = 2, mostrar la nota
    if (row.recoveryStatus === 2) return row.recoveryGrade || "-";
    // En cualquier otro caso, mostrar "-"
    return "-";
  };

  const tableConfig = {
    headers: ["Apellidos y Nombres", "DNI", "Registro académico"],
    fields: [
      {
        field: "User.lastname+ +User.secondLastname+ +User.firstname",
        dataType: "text",
      },
      {
        field: "User.dni",
        dataType: "text",
        align: "center",
      },
      {
        field: "Courses",
        tableConfig: {
          headers: [
            "Asignatura",
            "Progreso",
            "Cuestionarios",
            "Trabajo Final",
            "Conducta",
            "Recuperación",
            "Promedio",
            "Estado",
            "Acciones",
          ],
          fields: [
            {
              field: "SyllabuSubjectGrade.subject.name",
              dataType: "text",
            },
            {
              field: `progress+ +"%"`,
              component: "Label",
              getColor: getProgressColor,
              getText: getProgressText,
              align: "center",
            },
            {
              field: "questionnaireGrade",
              dataType: "text",
              align: "center",
            },
            {
              field: "homeworkGrade",
              dataType: "text",
              align: "center",
            },
            {
              field: "conductGrade",
              dataType: "text",
              align: "center",
            },
            {
              field: "recoveryGrade",
              component: "custom",
              align: "center",
              render: (row) => getRecoveryGradeDisplay(row),
            },
            {
              field: "averageGrade",
              dataType: "text",
              align: "center",
            },
            {
              field: "recoveryStatus",
              component: "Label",
              getColor: getStatusColor,
              getText: getStatusText,
              align: "center",
            },
            {
              buttons: [
                {
                  color: "orange",
                  icon: "line chart",
                  placeholder: "Historial Académico",
                  onClick: onOpenCloseModalAcademicHistory,
                },
                {
                  color: "blue",
                  icon: "edit",
                  placeholder: "Editar notas",
                  onClick: onOpenCloseEditGradeModal,
                },
                {
                  color: "green",
                  icon: "redo",
                  placeholder: "Recuperación de curso",
                  onClick: onOpenCloseRecoveryModal,
                  disabled: "row.averageGrade > 10 || row.recoveryStatus == 2",
                },
              ],
            },
          ],
          columnWidths: [
            "20%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
          ],
        },
        color: "blue",
        component: "CustomTable",
      },
    ],
    columnWidths: ["20%", "10%", "70%"],
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [gradeId]);

  useEffect(() => {
    (async () => {
      try {
        const response = await studentController.getStudentsAndAcademicAdvance(
          accessToken,
          gradeId,
          academicCycle.id,
          filters,
          currentPage,
          itemsPerPage
        );

        // Enriquecer los datos: agregar studentId a cada curso
        if (response && response.data) {
          const enrichedData = response.data.map((student) => ({
            ...student,
            Courses:
              student.Courses?.map((course) => ({
                ...course,
                studentId: student.id, // Agregar el studentId del padre a cada curso
              })) || [],
          }));

          setStudents({
            ...response,
            data: enrichedData,
          });
        } else {
          setStudents(response);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [gradeId, currentPage, reload, filters, itemsPerPage]);

  // Filter handlers
  const handleSearchInputChange = (field, value) => {
    setSearchInputs((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setFilters({ ...searchInputs });
    onReload();
  };

  const handleClearFilters = () => {
    setSearchInputs({ name: "", dni: "", phone: "" });
    setFilters({ name: "", dni: "", phone: "" });
    setCurrentPage(1);
    onReload();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const getFullName = (user) => {
    if (!user) return "";
    const { firstname, lastname, secondLastname } = user;
    return `${lastname ? ` ${lastname}` : ""} ${
      secondLastname ? ` ${secondLastname}` : ""
    } ${firstname ? ` ${firstname}` : ""}`;
  };

  const fullName = getFullName(studentActive?.User);

  if (!students) return <Loader active inline="centered" />;

  return (
    <>
      {/* Filters */}
      <div className="student__list-filters">
        <Input
          icon="search"
          iconPosition="left"
          placeholder="Buscar por nombre..."
          value={searchInputs.name}
          onChange={(e) => handleSearchInputChange("name", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Input
          icon="id card"
          iconPosition="left"
          placeholder="Buscar por DNI..."
          value={searchInputs.dni}
          onChange={(e) => handleSearchInputChange("dni", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Input
          icon="phone"
          iconPosition="left"
          placeholder="Buscar por teléfono..."
          value={searchInputs.phone}
          onChange={(e) => handleSearchInputChange("phone", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Button primary onClick={handleSearch}>
          <Icon name="search" /> Buscar
        </Button>
        <Button color="grey" onClick={handleClearFilters}>
          <Icon name="eraser" /> Limpiar filtros
        </Button>
      </div>
      
      <div className="student__list">
        <CustomTable
          color="teal"
          tableConfig={tableConfig}
          data={students.data}
          pagination={students.pagination}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onItemsPerPageChange={handleItemsPerPageChange}
          onReload={onReload}
        />
      </div>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Eliminar el estudiante ${fullName}?`}
        size="mini"
      />
      <BasicModal
        size="large"
        title={`Historial Académico - ${selectedCourse}`}
        show={showModalAcademicHistory}
        close={onOpenCloseModalAcademicHistory}
        className="academic-history-modal"
      >
        <AcademicHistory
          academicHistory={academicHistoryActive}
          studentId={studentActive}
        />
      </BasicModal>
      <BasicModal
        size="small"
        title={`Recuperación de Curso - ${
          recoveryActiveCourse?.SyllabuSubjectGrade?.subject?.name || ""
        }`}
        show={showRecoveryModal}
        close={() => onOpenCloseRecoveryModal(null)}
      >
        {recoveryActiveCourse && (
          <RecoveryGradeForm
            close={() => onOpenCloseRecoveryModal(null)}
            onReload={onReload}
            courseData={recoveryActiveCourse}
          />
        )}
      </BasicModal>
      <BasicModal
        size="small"
        title={`Editar Notas - ${
          editGradeActiveCourse?.SyllabuSubjectGrade?.subject?.name || ""
        }`}
        show={showEditGradeModal}
        close={() => onOpenCloseEditGradeModal(null)}
      >
        {editGradeActiveCourse && (
          <EditGradeForm
            close={() => onOpenCloseEditGradeModal(null)}
            onReload={onReload}
            courseData={editGradeActiveCourse}
          />
        )}
      </BasicModal>
    </>
  );
}
